import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getIdentidadesGenero } from '../../../api';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var COLUNAS_FUNCIONALIDADE = [
    {
        field: 'nome',
        headerName: 'Nome',
        width: 650,
    },
    {
        field: 'situacao',
        headerName: 'Situação',
        width: 150,
    },
];
var IdentidadesGenero = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.IDENTIDADES_GENERO, paginaPermissao: FUNCIONALIDADES.IDENTIDADES_GENERO, rota: ROUTES.IDENTIDADES_GENERO, fetchData: getIdentidadesGenero, columns: COLUNAS_FUNCIONALIDADE, renderFiltros: function (filtros, atualizar) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizar({ situacao: novaSituacao });
            } })); } }));
};
export default IdentidadesGenero;
